import {z} from 'zod';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {clinchEnums} from '@cl/shared';
import {CLEnumKeys, CLEnumType} from 'common/src/modules/enums/enums.types';
import {CampaignSetupAgentToolName} from '../campaignSetupAgent.enums';
import {baseCardSchema} from './baseSchemas';
import {ContentSelectionStrategyValue} from 'common/src/modules/contentFeeds/contentFeeds.enums';

const {loadedEnumsSubject} = clinchEnums;

// Content Card Schema
const contentCardConditionSchema = z.object({
  feedColumnSignalKey: z
    .string()
    .describe(
      `The feed column signal key, use the value from the columns array in the ${CampaignSetupAgentToolName.GetContentFeedColumns} tool`,
    ),
  operator: z
    .number()
    .describe(
      `match the user request to one of the following options: ${loadedEnumsSubject.data[
        CLEnumType.CampaignPage
      ]?.[CLEnumKeys.CampaignPage.ProductSelectionOperator]?.enumsForSelector
        .map((enumValue) => `${enumValue.name}: ${enumValue.value}`)
        .join(', ')}`,
    ),
  signalKey: z
    .string()
    .describe(
      `The signal key, use the signalKey from the signals array in the ${CampaignSetupAgentToolName.GetContentSignals} tool`,
    ),
  feedKey: z.number().describe('The feed key identifier'),
});

export const contentCardSchema = baseCardSchema.extend({
  type: z.literal(NodeType.CONTENT_FEED),
  conditions: z
    .array(contentCardConditionSchema)
    .describe(
      `Array of content conditions, should be populated if the strategy is ${ContentSelectionStrategyValue.Matching}`,
    )
    .nullable(),
  strategy: z.nativeEnum(ContentSelectionStrategyValue).describe('The strategy type').nullable(),
  contentId: z
    .string()
    .describe(
      `The content ID, should be populated if the strategy is ${ContentSelectionStrategyValue.Specific}`,
    )
    .nullable(),
  contentFeedId: z.number().nullable().describe('The content feed ID, can be left empty'),
  contentSetId: z.number().nullable().describe('The content set ID, can be left empty')
});
